import React from "react";
import { SupText } from "@repo/core-ui";

import { SupTxChain } from "../../TxChain";
import { SupTxStatus } from "../../TxStatus";
import type { StatusServiceProps } from "../../types";

export function StatusServiceValue({ img, status, name, url }: StatusServiceProps) {
  return (
    <SupText as="div" variant="subtitle1" className="inline-flex items-center gap-2 whitespace-nowrap">
      <SupTxStatus value={status} />
      {name && (
        <>
          <span>TRACK ON</span>
          <SupTxChain chainLogo={img} chainName={name} explorerUrl={url} />
        </>
      )}
    </SupText>
  );
}
